import { render, staticRenderFns } from "./ProductTypeIndex.vue?vue&type=template&id=ca590a00&"
import script from "./ProductTypeIndex.vue?vue&type=script&lang=js&"
export * from "./ProductTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports